<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12>
          <v-card class="app-card">
            <v-card-title class="app-card-title mb-0">
              <v-icon>assignment</v-icon>Cadastro Transportadora
            </v-card-title>
            <v-card-text class="app-card-content pl-0 pr-0 pb-0">
              <v-alert icon="warning" prominent text type="info" class="mb-0">
                <strong
                  >Instruções para Pedido de Inclusão de Transportadora</strong
                >
                <br />
                <strong>1</strong> - Na tela de cadastro de contato, preencha os
                dados do contato principal da transportadora e clique em
                continuar; <br />
                <strong>2</strong> - Enviaremos um código para o email
                cadastrado; <br />
                <strong>3</strong> - Na tela de cadastro da transportadora,
                preencha os dados da transportadora, insira o código enviado por
                email no campo indicado e clique em continuar; <br />
                <strong>4</strong> - Faça o upload dos documentos, preenchendo
                os campos referentes aos mesmos e clique em continuar; <br />
                <strong>5</strong> - Pronto, seu pedido foi submetido para
                análise da Agência. <br />
              </v-alert>
              <v-stepper
                v-model="form.currentStep"
                outlined
                alt-labels
                class="app-stepper"
              >
                <v-stepper-header class="app-stepper-header">
                  <v-stepper-step
                    :complete="form.currentStep > 1"
                    step="1"
                    class="app-stepper-header__step"
                    color="primary"
                  >
                    Infor. Contato
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step
                    :complete="form.currentStep > 2"
                    step="2"
                    class="app-stepper-header__step"
                    color="primary"
                  >
                    Infor. Transportadora
                  </v-stepper-step>
                  <v-divider />
                  <v-stepper-step
                    :complete="form.currentStep > 3"
                    step="3"
                    class="app-stepper-header__step"
                    color="primary"
                  >
                    Documentos
                  </v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <FormContact v-if="!allUploadeds" />
                    <FinishMessage v-else :typeSolicitation="solicitationId" />
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <ShippingCompanyForm />
                  </v-stepper-content>
                  <v-stepper-content step="3">
                    <DocumentosForm
                      v-if="form.currentStep === 3"
                      :resourceId="form.pedido.id"
                      :typeSolicitation="form.pedido.tipoPedido"
                    />
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import DocumentosForm from "../components/documentos/Form";

// Vuex Store - Sit Pedidos (mapping actions and states)
import { mapState, mapActions, mapMutations } from "vuex";
const actions = mapActions("sitPedidos", ["clearForm", "setFormDocuments"]);
const state = mapState("sitPedidos", ["form"]);
import GlobalStore from "@/store/modules/global";

import ShippingCompanyForm from "./components/transportadora/FormShippingCompany";
import FormContact from "./components/transportadora/FormContact";
import FinishMessage from "./components/transportadora/FinishMessage";

export default {
  name: "RenovacaoTransportadora",

  components: {
    ShippingCompanyForm,
    FormContact,
    DocumentosForm,
    FinishMessage,
  },

  data: () => ({
    allUploadeds: false,

    solicitationId: null,
  }),

  computed: {
    ...state,
  },

  watch: {
    "form.documents": function (newValue, oldValue) {
      if (newValue && newValue.length) {
        this.allUploadeds = newValue.every((d) => d.uploaded);

        if (this.allUploadeds) {
          this.solicitationId = this.form.pedido.id;
          this.clearForm();
          //GlobalStore.setSnackBar({message: "Pedido criado com sucesso", type: 'success', show: true, timeout: 5000})
        }
      }
    },
  },

  destroyed() {
    this.clearForm();
  },

  methods: {
    ...actions,
  },
};
</script>
